<template lang="html">
  <v-list-item @click="$emit('click', channel)">
    <v-badge color="error" :value="!!badgeValue">
      <template #badge>
        {{ badgeValue }}
      </template>

      <v-list-item-content>
        <v-list-item-title>{{
          cleanChannelName(
            channel.channelName || channel.channel_name || channel.name
          )
        }}</v-list-item-title>
        <v-list-item-subtitle>Kanal ID: {{ channel.cid }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-badge>
  </v-list-item>
</template>

<script>
export default {
  props: {
    badgeValue: {
      type: [Number, String],
      default: 0,
    },
    channel: Object,
  },
  methods: {
    cleanChannelName(name) {
      if (!name) return "";

      let s = String(name);

      // 1) Baştaki [ .... ] bloğunda spacer geçen her şeyi komple sil
      // Örn: [cspacer1]  [*spacer488aa0]  [lspacerᎮ]  [cspacer]  [spacer___]
      s = s.replace(/^\s*\[\s*[^]*?spacer[^]*?\]\s*/i, "");

      // 2) Parantezsiz başlayanlar: cspacer1 lspacerX *spacerABC spacer123
      s = s.replace(/^\s*\*?\s*(?:cspacer|lspacer|spacer)\S*\s*/i, "");

      return s.trim();
    },
  },
};
</script>

<style lang="css" scoped></style>
